import { render } from "./AboutProductMedia.vue?vue&type=template&id=1195b500&scoped=true"
import script from "./AboutProductMedia.vue?vue&type=script&lang=js"
export * from "./AboutProductMedia.vue?vue&type=script&lang=js"

import "./AboutProductMedia.vue?vue&type=style&index=0&id=1195b500&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1195b500"],['__file',"webpack-assets/vue/templates/product/catalog/parts/AboutProductMedia.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1195b500"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1195b500', __exports__)) {
    api.reload('1195b500', __exports__)
  }
  
  module.hot.accept("./AboutProductMedia.vue?vue&type=template&id=1195b500&scoped=true", () => {
    api.rerender('1195b500', render)
  })

}


export default __exports__